module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "sign-up"
  }, [(_vm.error) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isFirstStep) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('snackbar', {
    attrs: {
      "text": _vm.errorText,
      "color": _vm.snackbarColor,
      "show": _vm.showErrorMissingData,
      "timeOut": 2000
    },
    on: {
      "update:show": function($event) {
        _vm.showErrorMissingData = $event
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Creá tu cuenta")]), _vm._v(" "), _c('v-container', [_c('v-form', {
    model: {
      value: (_vm.validStep1),
      callback: function($$v) {
        _vm.validStep1 = $$v
      },
      expression: "validStep1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "face",
      "name": "name",
      "label": "Nombre y Apellido",
      "id": "name",
      "type": "name",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "padding",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "email",
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "rules": _vm.$ponceConfig.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "padding"
  }, [_vm._v("Definí tu rol")]), _vm._v(" "), _c('v-container', [_c('v-select', {
    attrs: {
      "label": "Rol",
      "prepend-icon": "person",
      "item-text": "label",
      "item-value": "id",
      "items": _vm.allRoles
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "create-button",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onContinue()
      }
    }
  }, [_vm._v("Continuar")])], 1)], 1)], 1)], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('snackbar', {
    attrs: {
      "text": _vm.errorText,
      "color": _vm.snackbarColor,
      "show": _vm.showErrorMissingData,
      "timeOut": 2000
    },
    on: {
      "update:show": function($event) {
        _vm.showErrorMissingData = $event
      }
    }
  }), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.validStep2),
      callback: function($$v) {
        _vm.validStep2 = $$v
      },
      expression: "validStep2"
    }
  }, [_c('h2', [_vm._v("Establecé tu contraseña")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "lock",
      "name": "password",
      "label": "Contraseña",
      "id": "password",
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'visibility_off' : 'visibility',
      "rules": _vm.$ponceConfig.passwordRules,
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "padding"
  }, [_vm._v("Validación")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "phone",
      "name": "phoneNumber",
      "id": "phoneNumber",
      "label": "ej: +549223XXXXXXX",
      "type": "phoneNumber",
      "rules": _vm.$ponceConfig.phoneRules,
      "required": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "create-button",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.onSignup
    }
  }, [_vm._v("Crear cuenta")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65671136","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signup.vue
// module id = 775
// module chunks = 13